import React, { FC, HTMLAttributes, MouseEventHandler, useMemo } from 'react';
import classNames from 'classnames';
import { FaIcon } from 'components/ui';
import styles from './ImagePreview.module.scss';

export interface IImagePreview extends HTMLAttributes<HTMLDivElement> {
  image: string;
  size: PreviewSizeSelector;
  onUpload?: MouseEventHandler;
  hasBorder?: boolean;
}

interface PreviewSizeOption {
  width: number;
  height: number;
}

export enum PreviewSizeSelector {
  small = 'small',
  large = 'large',
}

const ImagePreview: FC<IImagePreview> = ({ className, image, size }) => {
  const rootClassName = classNames(styles['ta-image__preview'], className, {
    [styles['ta-image__preview__small']]: size === 'small',
  });
  const sizes = useMemo(
    () => ({
      [PreviewSizeSelector.small]: { width: 32, height: 32 },
      [PreviewSizeSelector.large]: { width: 120, height: 60 },
    }),
    []
  );
  const previewSize: PreviewSizeOption = sizes[size];

  return (
    <div className={rootClassName}>
      {image ? (
        <img
          {...previewSize}
          src={image}
          alt='App logo preview'
          className={styles['ta-image__preview__image']}
        />
      ) : (
        <FaIcon
          iconPrefix='far'
          icon='cloud-upload-alt'
          className={styles['ta-image__preview__upload-icon']}
        />
      )}
    </div>
  );
};

export default ImagePreview;
